module.exports = __webpack_public_path__ + "img/TIE.6ff36077.png";